import { Component } from '@angular/core';
import { UserRoles } from '@troyai/auth/data-access';
import { RolesDirective } from '@troyai/auth/feature';
import { AircallWrapperComponent } from '@troyai/portal/voice-calls/feature';

@Component({
  selector: 't-root-components',
  imports: [RolesDirective, AircallWrapperComponent],
  templateUrl: './root-components.component.html',
  styles: [
    `
      :host {
        display: block;
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: 99999;
      }
    `,
  ],
})
export class RootComponentsComponent {
  userRoles = UserRoles;
}
